export const SERVICE = 'VENDOR_DETAILS'
